import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ContactFormService } from 'src/app/contact-form.service';

@Component({
  selector: 'app-eftes-landing',
  templateUrl: './eftes-landing.component.html',
  styleUrls: ['./eftes-landing.component.scss']
})
export class EftesLandingComponent implements OnInit, OnDestroy {
  public eventoId: string;
  public isSubmitted = false;
  public formLoading = false;
  public formularioEnviado = false;
  public fileUrl: string | null = null;
  public fileTitle: string | null = null;
  public errorMessage: string | null = null;

  // Assets locales del front. Se bundlean en build time (Angular los copia
  // a dist/ al hacer `ng build`). Para cambiarlos en el futuro, basta con
  // reemplazar el archivo en src/assets/img/eftes/ y rebuild.
  // Rutas absolutas: en /eftes/:id las URLs relativas resuelven mal (p. ej. /eftes/assets/...).
  public backgroundUrl = '/assets/img/eftes/bridlington-hero.webp';
  public logoUrl = '/assets/img/eftes/eftes-logo.png';

  contactForm = this.formBuilder.group({
    first_name: ['', Validators.required],
    surname:    ['', Validators.required],
    email:      ['', [Validators.required, Validators.email]],
    telefono:   ['', Validators.required],
    company:    ['', Validators.required],
  });

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private contactService: ContactFormService,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.renderer.addClass(document.body, 'eftes-active');
    this.titleService.setTitle('How a UK Hospital Uses Battery Storage to Optimise Energy Costs');
    this.route.params.subscribe(params => {
      this.eventoId = params['id'];
    });
    // Ocultar navbar y footer globales del app shell mientras la landing esta montada.
    // Lo hacemos por JS (no por CSS) porque ::ng-deep no siempre perfora hacia arriba
    // en la jerarquia, dependiendo del View Encapsulation.
    this.toggleAppShell(false);
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'eftes-active');
    this.toggleAppShell(true);
  }

  private toggleAppShell(visible: boolean) {
    const display = visible ? '' : 'none';
    ['app-navbar', 'app-footer'].forEach(tag => {
      const els = document.getElementsByTagName(tag);
      for (let i = 0; i < els.length; i++) {
        (els[i] as HTMLElement).style.display = display;
      }
    });
  }

  submit() {
    this.isSubmitted = true;
    if (this.contactForm.invalid) return;

    this.formLoading = true;
    this.errorMessage = null;

    const payload = {
      nombre:   this.contactForm.value.first_name,
      apellido: this.contactForm.value.surname,
      email:    this.contactForm.value.email,
      telefono: this.contactForm.value.telefono,
      compania: this.contactForm.value.company,
      evento:   this.eventoId,
    };

    this.contactService.createSolicitudEftes(payload).subscribe({
      next: (r: any) => {
        const data = r.message || r;
        this.fileUrl = data.file_url;
        this.fileTitle = data.titulo;
        this.formularioEnviado = true;
        this.formLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.errorMessage = 'Something went wrong. Please try again.';
        this.formLoading = false;
      }
    });
  }

  downloadFile() {
    if (!this.fileUrl) return;
    window.location.href = '/api/method/atr_marketing.solicitud.downloadFile?name=' + encodeURIComponent(this.fileUrl);
  }
}
